export const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const USER_DATA_ERROR = 'USER_DATA_REQUEST';
export const USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_ERROR = 'USER_UPDATE_PROFILE_ERROR';
export const USER_HAS_UPDATED_PROFILE = 'USER_HAS_UPDATED_PROFILE';
export const USER_LOCALE_CHANGE = 'USER_LOCALE_CHANGE';
export const USER_TEAMLEADER_OAUTH = 'USER_TEAMLEADER_OAUTH';
export const USER_TEAMLEADER_OAUTH_SUCCESS = 'USER_TEAMLEADER_OAUTH_SUCCESS';
export const USER_TEAMLEADER_OAUTH_ERROR = 'USER_TEAMLEADER_OAUTH_ERROR';
export const USER_LOG_IN = 'USER_LOG_IN';
export const USER_LOG_IN_SUCCESS = 'USER_LOG_IN_SUCCESS';
export const USER_LOG_IN_ERROR = 'USER_LOG_IN_ERROR';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const TRADER_INVOICES = 'TRADER_INVOICES';
export const TRADER_INVOICES_SUCCESS = 'TRADER_INVOICES_SUCCESS';
export const TRADER_INVOICES_ERROR = 'TRADER_INVOICES_ERROR';
